var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisioconference(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-linecap:round;stroke-width:2px;}.cls-1,.cls-3{stroke:#e6007e;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#e6007e;}.cls-3{stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visio_conf",
    "data-name": "visio conf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,17.28a.73.73,0,0,0-.73.73.73.73,0,0,0,1.46,0A.73.73,0,0,0,33,17.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.26,29.64A15.27,15.27,0,1,0,29.32,44.47a5.55,5.55,0,0,1-1,2.77h0a6.88,6.88,0,0,0-3.13.63,3.16,3.16,0,0,0-1.66,3,.73.73,0,0,0,.73.73H41.72a.73.73,0,0,0,.72-.73,3.15,3.15,0,0,0-1.66-3,6.81,6.81,0,0,0-3.12-.63h0a5.55,5.55,0,0,1-1-2.77A15.32,15.32,0,0,0,48.26,29.64ZM37.35,48.7c2.42,0,3.3.56,3.55,1.45H25.08a1.55,1.55,0,0,1,.81-1,6,6,0,0,1,2.74-.46Zm-7.3-1.46a9.11,9.11,0,0,0,.7-2.49,14.84,14.84,0,0,0,4.48,0,8.77,8.77,0,0,0,.7,2.49Zm5.7-4.06h0a14.24,14.24,0,0,1-5.52,0h0a13.83,13.83,0,1,1,5.53,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.71,22a12.41,12.41,0,0,0-6.65-4.34.72.72,0,1,0-.36,1.4,11,11,0,0,1,5.86,3.84.74.74,0,0,0,1,.12A.73.73,0,0,0,42.71,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,21.64a8,8,0,1,0,8,8A8,8,0,0,0,33,21.64Zm0,14.55a6.55,6.55,0,1,1,6.55-6.55A6.56,6.56,0,0,1,33,36.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,24.55a5.1,5.1,0,1,0,5.09,5.09A5.1,5.1,0,0,0,33,24.55Zm0,8.73a3.64,3.64,0,1,1,3.64-3.64A3.64,3.64,0,0,1,33,33.28Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisioconference);
export default __webpack_public_path__ + "static/media/visioconference.d3a90126ebd7ab7acd562d9fc8a8c872.svg";
export { ForwardRef as ReactComponent };